export function areCookiesAvailable(): boolean {
  return navigator.cookieEnabled;
}
